import { render, staticRenderFns } from "./BloqueTutorPracticas.vue?vue&type=template&id=0771a386&scoped=true"
import script from "./BloqueTutorPracticas.vue?vue&type=script&lang=js"
export * from "./BloqueTutorPracticas.vue?vue&type=script&lang=js"
import style0 from "./BloqueTutorPracticas.vue?vue&type=style&index=0&id=0771a386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0771a386",
  null
  
)

export default component.exports